export default {"src":"/assets/_next/static/media/mastercard.728a3020.svg","height":776,"width":999,"blurWidth":0,"blurHeight":0};